import React, { Component } from 'react';
import { Avatar, Icon } from 'antd';
import {
  Container,
  SettingpageConatiner,
  SidenavContainer,
  LoaderContainer,
  SidebarHeadCover,
  SidebarUserDetail,
  UserConatiner,
  SidebarTab,
  Detailwrapper,
} from './styles';
import Loader from '../../components/Loader';
import ManageUsers from './ManageUsers';
import MulticloudSettings from './MulticloudSettings';
import LanguageSettings from './LanguageSettings';
import { AppStoreContext } from '../../context/appStoreContext';
import {
  LanguageIcon,
  MailServer,
  FaxIcon,
  PrinterSvgIcon,
  TwilioIcon,
  TextToSpeechIcon,
  ssoIcon,
} from '../../components/SidebarMenuIcons';
import TeamSettings from './TeamSettings';
import LicenseSettings from './LicenseSettings';
import PrinterSettings from './PrinterSettings';
import FaxConfigSettings from './FaxConfigSettings';
import SMTPServerConfig from './SMTPServerConfig';
import TwilioAccountSettings from './TwilioAccountSettings';
import TextToSpeechConfig from './TextToSpeechConfig';
import { withTranslation } from 'react-i18next';
import { USER_ACCOUNT_SETTING_TABS as trans } from './TranslationValues';
import { removeDuplicateFirstNames } from './../../utils/javascript';
import { ENABLE_EMAIL_DESIGNS } from '../../utils/helper';
import AlertsAndNotifications from './AlertsAndNotifications';
import SingleSignOnSettings from './SingleSignOnSettings';
import ExternalServices from './ExternalServices';


const NAMESPACE = ['USER_ACCOUNT_SETTING_TABS'];

class UserSettingsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      tabIndex: 1,
    };
  }

  static contextType = AppStoreContext;

  async componentDidMount() {
    const { checkUserAccess, isEnterprise, checkUserAccessRoles } = this.context;
    if(isEnterprise && checkUserAccessRoles(['MAILROOMADMIN'])) {
      this.setState({
        tabIndex: 9,
      });
    }
    if(isEnterprise && checkUserAccessRoles(['ADMIN'])) {
      this.setState({
        tabIndex: 5,
      })
    }
    if (checkUserAccess('master')) {
      this.setState({
        tabIndex: 2,
      });
    }
    this.setState({
      isLoading: false,
    });
  }

  selectHandler = id => {
    this.setState({
      tabIndex: id,
    });
  };

  renderSidebar = (currentIndex, icon, title, isComponent = false) => {
    const { tabIndex } = this.state;
    return (
      <SidebarTab
        active={tabIndex === currentIndex}
        textToSpeech={currentIndex === 11}
        onClick={() => this.selectHandler(currentIndex)}
      >
        {isComponent ? <Icon component={icon} /> : <Icon type={icon} />}
        <div
          style={{
            display: 'inline-block',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            width: '230px',
          }}
          title={title}
        >
          {title}
        </div>
      </SidebarTab>
    );
  };

  render() {
    const {t} = this.props
    const { isLoading, tabIndex } = this.state;
    const { userDetails, isEnterprise, checkUserAccessRoles } = this.context;
    const adminUser = checkUserAccessRoles(['ADMIN']);
    const mailRoomAdmin = checkUserAccessRoles(['MAILROOMADMIN']);
    const { displayName, firstName, lastName } = userDetails;

    return (
      <React.Fragment>
        <Container>
          <UserConatiner>
            {isLoading ? (
              <LoaderContainer>
                <Loader />
              </LoaderContainer>
            ) : (
              <SettingpageConatiner>
                <SidenavContainer>
                  <SidebarHeadCover>
                    <Avatar icon="user" className="avatar" size="large" />
                    {userDetails && (
                      <SidebarUserDetail>
                        <h5>{removeDuplicateFirstNames(displayName) || ((firstName || lastName) && `${firstName.trim()} ${lastName !== null ? lastName : ''}`)}</h5>
                        {/* <p>{loggedIn.data.uniqueId}</p> */}
                      </SidebarUserDetail>
                    )}
                  </SidebarHeadCover>
                  {isEnterprise && adminUser &&
                    this.renderSidebar(5, 'key', t(trans.MANAGE_LICENSE_TAB.key,trans.MANAGE_LICENSE_TAB.value))}
                  {isEnterprise && adminUser &&
                    this.renderSidebar(8, ssoIcon, t(trans.MANAGE_SSO.key,trans.MANAGE_SSO.value), true)}
                  {adminUser && 
                    this.renderSidebar(1, 'team', t(trans.MANAGE_TEAMS_TAB.key,trans.MANAGE_TEAMS_TAB.value))}
                  {adminUser &&
                    this.renderSidebar(2, 'user', t(trans.MANAGE_USERS_TAB.key,trans.MANAGE_USERS_TAB.value))}
                  {isEnterprise && adminUser &&
                    this.renderSidebar(3, 'cloud-upload', t(trans.MANAGE_STORAGE_TAB.key,trans.MANAGE_STORAGE_TAB.value))}
                  {adminUser && 
                    this.renderSidebar(4, LanguageIcon, t(trans.MANAGE_LANGUAGE_TAB.key,trans.MANAGE_LANGUAGE_TAB.value), true)}
                  {ENABLE_EMAIL_DESIGNS && adminUser &&
                    this.renderSidebar(6, MailServer, t(trans.MANAGE_SMTP_SERVER_TAB.key,trans.MANAGE_SMTP_SERVER_TAB.value), true)}
                  {isEnterprise && adminUser &&
                    this.renderSidebar(7, FaxIcon, t(trans.MANAGE_FAX_CONFIGURATION_TAB.key,trans.MANAGE_FAX_CONFIGURATION_TAB.value), true)}
                  {isEnterprise && mailRoomAdmin &&
                    this.renderSidebar(9, PrinterSvgIcon, t(trans.MANAGE_PRINTER_CONFIGURATION_TAB.key,trans.MANAGE_PRINTER_CONFIGURATION_TAB.value), true)}
                  {isEnterprise && adminUser &&
                    this.renderSidebar(10, TwilioIcon, t(trans.MANAGE_SHORT_MESSAGE_CONFIGURATION_TAB.key,trans.MANAGE_SHORT_MESSAGE_CONFIGURATION_TAB.value), true)}
                  {/* this.renderSidebar(11, TextToSpeechIcon, t(trans.MANAGE_TEXT_TO_SPEECH_CONFIGURATION_TAB.key,trans.MANAGE_TEXT_TO_SPEECH_CONFIGURATION_TAB.value), true) */}
                  {!isEnterprise && adminUser &&
                    this.renderSidebar(12, 'bell', t(trans.ALERTS_AND_NOTIFICATIONS_TAB.key, trans.ALERTS_AND_NOTIFICATIONS_TAB.value))}
                  {isEnterprise &&
                    this.renderSidebar(13, 'cluster', t(trans.EXTERNAL_SERVICES_TAB.key, trans.EXTERNAL_SERVICES_TAB.value), false)}
                    </SidenavContainer>
                <Detailwrapper>
                  {tabIndex === 1 && <TeamSettings />}
                  {tabIndex === 2 && <ManageUsers />}
                  {tabIndex === 3 && <MulticloudSettings />}
                  {tabIndex === 4 && <LanguageSettings />}
                  {tabIndex === 5 && <LicenseSettings />}
                  {tabIndex === 6 && <SMTPServerConfig />}
                  {tabIndex === 7 && <FaxConfigSettings />}
                  {tabIndex === 8 && <SingleSignOnSettings />}
                  {tabIndex === 9 && (
                    <PrinterSettings isEditable={mailRoomAdmin} />
                  )}
                  {tabIndex === 10 && <TwilioAccountSettings />}
                  {tabIndex === 11 && <TextToSpeechConfig />}
                  {tabIndex === 12 && <AlertsAndNotifications />}
                  {tabIndex === 13 && <ExternalServices />}
                </Detailwrapper>
              </SettingpageConatiner>
            )}
          </UserConatiner>
        </Container>
      </React.Fragment>
    );
  }
}
export default withTranslation(NAMESPACE)(UserSettingsPage);
